export interface ProjectedDynamicAttribute {
  attribute: string;
  value: string | null;
}

export function buildDynamicAttributeVariables(dynamicAttributePaths?: string[]): {
  dynamicAttributePaths?: string[];
  hasCustomAttributes: boolean;
} {
  const hasCustomAttributes = Boolean(dynamicAttributePaths?.length);

  return {
    dynamicAttributePaths: hasCustomAttributes ? dynamicAttributePaths : undefined,
    hasCustomAttributes,
  };
}
